class Component {

    constructor(element) {
        // component configuration
        this.config = {
            toggleStackedAttribute: 'data-navigation-toggle-stacked',
            scrollAnchorSelector: '[data-navigation-scroll-anchor]',
            stackedClass: 'is-stacked'
        };

        // component properties
        this.root = element;
        this.scrollAnchor = document.querySelector(this.config.scrollAnchorSelector);
        this.scrollAnchorPosition = 0;

        // bind to events
        window.addEventListener('scroll', event => this.toggleStacked(event));

        // if a scroll anchor exists in the page, set the bottom of the element as the anchor position
        if (this.scrollAnchor) {
            this.scrollAnchorPosition = this.scrollAnchor.getBoundingClientRect().bottom;
        }
    }

    toggleStacked() {
        const position = document.documentElement.scrollTop || document.body.scrollTop;
        const isStackable = this.root.hasAttribute(this.config.toggleStackedAttribute);

        if (isStackable) {
            position > this.scrollAnchorPosition ? this.root.classList.remove(this.config.stackedClass) :
                this.root.classList.add(this.config.stackedClass);
        }
    }
}

const enhanceElement = (element) =>
    element ? new Component(element) : false;

const enhance = () =>
    enhanceElement(document.querySelector('[data-navigation]'));

export default {enhance};
